import { storeModuleName } from "@/services/employeeAccess/employeeAccessService";
import {
  SET_MODULE,
  SET_PERMITTED_MODULES,
  SET_NOTIFICATIONS,
  SET_MY_TIMES,
  SET_MY_TIME,
  SET_MY_TIME_OFF_BALANCE,
  SET_MY_TIME_OFF,
  SET_REQUEST_TRAIL,
  SET_TEAM_TIME,
  SET_EMPLOYEES_UNDER,
  SET_MY_PAYS,
  SET_MY_TASKS,
  SET_MY_TASKS_COUNT,
  SET_MY_TASK,
  SET_MY_PROFILE,
  SET_MY_BENEFITS,
  SET_MY_CAREER,
  SET_BROWSE_JOBS,
  SET_DASHBOARD_ANNOUNCEMENTS,
  SET_DASHBOARD_MY_TASKS,
  SET_DASHBOARD_UPCOMING_EVENTS,
  SET_USER_MANAGEMENT,
  SET_ROLES,
  SET_ROLES_ASSOCIATION,
  SET_ROLE_PERMISSIONS,
  SET_TIME_OFF_REQUEST_CREATED,
  SET_DIRECT_DEPOSITS,
  SET_PAYROLL_ITEMS,
  SET_PAYROLL_ITEM_DETAILS,
  SET_PAYROLL_CHECKS,
  SET_PAYROLL_CHECK_DETAILS,
  SET_PAYROLL_TASK,
  SET_PAYROLL_REGISTERED,
  SET_NEXT_STATUS_LIST_TASK,
  SET_ASSOCIATION_LIST,
  SET_COST_CENTERS,
  SET_USER_ASSIGNMENTS,
  SET_TIME_ENTRY_APPROVAL_REF_ID,
  SET_PAY_CYCLES,
  SET_PAY_CYCLE_DETAIL,
  SET_TASK_PERMISSION,
  SET_USER_GROUPS,
  SET_ASSIGNMENT_HISTORY,
  SET_TIME_OFF_ENTRIES,
  SET_TRANSACTION_DETAILS,
  SET_PUBLISHED_W2,
  SET_ATTRIBUTES,
  SET_DEPENDENTS,
  SET_REQUESTS
} from "@/store/employeeAccess/mutation-types";

const mutations = {
  /**
   * Set current module
   * @param state
   * @param {{title: String, icon: String, name: String, route: String}} module
   * @constructor
   */
  [SET_MODULE]: (state, module) => {
    state.module = module;
    if (module) {
      storeModuleName(module.name);
    }
  },
  [SET_PERMITTED_MODULES]: (state, newPermittedModules) => {
    state.permittedModules = newPermittedModules;
    // console.log("SET_PERMITTED_MODULES:", state["permittedModules"]);
  },
  /**
   * Set notifications
   * @param state
   * @param [{title: String, subtitle: String, priority: String}] payload
   */
  [SET_NOTIFICATIONS]: (state, payload) => {
    state["notifications"] = payload || [];
  },
  /**
   * SET_MY_*
   * @param state
   * @param payload
   */
  [SET_MY_TIMES]: (state, payload) => {
    state["myTimes"] = payload || [];
    // console.log("SET_MY_TIMES().myTimes:", state["myTimes"]);
  },
  [SET_MY_TIME]: (state, payload) => {
    state["myTime"] = payload || [];
    console.log("SET_MY_TIME().myTime:", state["myTime"]);
  },
  [SET_MY_TIME_OFF_BALANCE]: (state, payload) => {
    state["myTimeOffBalance"] = payload || [];
  },
  [SET_MY_TIME_OFF]: (state, payload) => {
    state["myTimeOff"] = payload || [];
  },
  [SET_REQUEST_TRAIL]: (state, payload) => {
    state["requestTrail"] = payload || [];
  },
  [SET_TEAM_TIME]: (state, payload) => {
    state["teamTime"] = payload || [];
  },
  [SET_EMPLOYEES_UNDER]: (state, payload) => {
    state["employeesUnder"] = payload || [];
  },
  [SET_MY_PAYS]: (state, payload) => {
    state["myPays"] = payload || [];
  },
  [SET_MY_TASKS]: (state, payload) => {
    state["myTasks"] = payload || [];
  },
  [SET_MY_TASKS_COUNT]: (state, payload) => {
    state["myTasksCount"] = payload || [];
  },
  [SET_MY_TASK]: (state, payload) => {
    state["myTask"] = payload || [];
  },
  [SET_MY_PROFILE]: (state, payload) => {
    state["myProfile"] = payload || [];
  },
  [SET_MY_BENEFITS]: (state, payload) => {
    state["myBenefits"] = payload || [];
  },
  [SET_MY_CAREER]: (state, payload) => {
    state["myCareer"] = payload || [];
  },
  [SET_BROWSE_JOBS]: (state, payload) => {
    state["browseJobs"] = payload || [];
  },
  [SET_DASHBOARD_ANNOUNCEMENTS]: (state, payload) => {
    state["dashboardAnnouncements"] = payload || [];
  },
  [SET_DASHBOARD_MY_TASKS]: (state, payload) => {
    state["dashboardMyTasks"] = payload || [];
  },
  [SET_DASHBOARD_UPCOMING_EVENTS]: (state, payload) => {
    state["dashboardUpcomingEvents"] = payload || [];
  },
  [SET_USER_MANAGEMENT]: (state, payload) => {
    state["userManagement"] = payload || [];
  },
  [SET_ROLES]: (state, payload) => {
    state["roles"] = payload || [];
  },
  [SET_ROLES_ASSOCIATION]: (state, payload) => {
    state["rolesAssociation"] = payload || [];
  },
  [SET_ROLE_PERMISSIONS]: (state, payload) => {
    state["rolePermissions"] = payload || [];
  },
  [SET_TIME_OFF_REQUEST_CREATED]: (state, payload) => {
    state["timeOffRequestCreated"] = payload || [];
  },
  [SET_DIRECT_DEPOSITS]: (state, payload) => {
    state["directDeposits"] = payload || [];
  },
  [SET_PAYROLL_ITEMS]: (state, payload) => {
    state["payrollItems"] = payload || [];
  },
  [SET_PAYROLL_ITEM_DETAILS]: (state, payload) => {
    state["payrollItemDetails"] = payload || [];
  },
  [SET_PAYROLL_CHECKS]: (state, payload) => {
    state["payrollChecks"] = payload || [];
  },
  [SET_PAYROLL_CHECK_DETAILS]: (state, payload) => {
    state["payrollCheckDetails"] = payload || [];
  },
  /**
   * Set payroll tasks
   * @param state
   * @param [{code: string, description: string, id: number, status: string}] payload
   */
  [SET_PAYROLL_TASK]: (state, payload) => {
    state["payrollTask"] = payload || [];
  },
  /**
   * Set Payroll Registered
   * @param state
   * @param payload
   */
  [SET_PAYROLL_REGISTERED]: (state, payload) => {
    state["payrollRegistered"] = payload || [];
  },
  /**
   * Set next status list of Task
   * @param state
   * @param [{id: number, value: string}] payload
   */
  [SET_NEXT_STATUS_LIST_TASK]: (state, payload) => {
    state["nextStatusListTask"] = payload || [];
  },
  /**
   * Set association list
   * @param state
   * @param [{id: number, assosOf: string, assos: string, assosWith: string}] payload
   */
  [SET_ASSOCIATION_LIST]: (state, payload) => {
    state["associationList"] = payload || [];
  },
  /**
   * Set cost centers
   * @param state
   * @param [{code: string, description: string, id: number, status: string}] payload
   */
  [SET_COST_CENTERS]: (state, payload) => {
    state["costCenters"] = payload || [];
  },
  /**
   * Set user assignments
   * @param state
   * @param [{code: string, description: string, id: number, status: string}] payload
   */
  [SET_USER_ASSIGNMENTS]: (state, payload) => {
    state["userAssignments"] = payload || [];
  },
  [SET_TIME_ENTRY_APPROVAL_REF_ID]: (state, payload) => {
    state["timeEntryApprovalRefId"] = payload || [];
  },
  [SET_PAY_CYCLES]: (state, payload) => {
    state["payCycles"] = payload || [];
  },
  [SET_PAY_CYCLE_DETAIL]: (state, payload) => {
    state["payCycleDetail"] = payload || [];
  },
  [SET_TASK_PERMISSION]: (state, payload) => {
    state["taskPermission"] = payload || [];
  },
  [SET_USER_GROUPS]: (state, payload) => {
    state["userGroups"] = payload || [];
  },
  [SET_ASSIGNMENT_HISTORY]: (state, payload) => {
    state["assignmentHistory"] = payload || [];
  },
  [SET_TIME_OFF_ENTRIES]: (state, payload) => {
    state["timeOffEntries"] = payload || [];
  },
  [SET_TRANSACTION_DETAILS]: (state, payload) => {
    state["transactionDetails"] = payload || [];
  },
  [SET_PUBLISHED_W2]: (state, payload) => {
    state["publishedW2"] = payload || [];
  },
  [SET_ATTRIBUTES]: (state, payload) => {
    state["attributes"] = payload || [];
  },
  [SET_DEPENDENTS]: (state, payload) => {
    state["dependents"] = payload || [];
  },
  [SET_REQUESTS]: (state, payload) => {
    state["requests"] = payload || [];
  }
};

export default mutations;
